// extracted by mini-css-extract-plugin
module.exports = {"marginBottom":"SectionHeader_marginBottom__vLaio","xs":"SectionHeader_xs__xjXdG","md":"SectionHeader_md__8XU2i","xl":"SectionHeader_xl__Ej7Kf"};